// extracted by mini-css-extract-plugin
export default {"dnews":"OurBlog_dnews__8ODo5","image":"OurBlog_image__2295A","arc":"OurBlog_arc__auqEW","background":"OurBlog_background__b0Brk"};